import React from "react";
import { motion } from "framer-motion";

const Header = () => {
  return (
    <motion.div
      id="home"
      className="container-fluid py-5 Header"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="row p-lg-5">
        <div className="col-12 text-center">
          <h1 className="mb-4 titre-principal">
            Je construis pour vous un site web sur-mesure et adapté à vos
            besoins.
          </h1>
          <h3 className="mb-4">
            Dynamisez votre activité avec un site web attrayant et performant,
            et faites de votre site votre meilleur argument de vente.
          </h3>
          <h5 className="mb-4">
            Transformez votre présence en ligne dès maintenant !
          </h5>
          <motion.button
            className="btn btn-primary rounded-pill px-4 py-2 "
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <a
              target="blank"
              className="text-decoration-none white-color"
              href="https://tally.so/r/m6vN5o"
            >
              Contactez-moi
            </a>
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default Header;
